export default {
  data: () => ({
    fiscalPosGuardando: false,
    fiscalPosCargando: false,
    fiscalPosSolicitud: 0,
    fiscalPosRnc: "",
    fiscalPosTimer: null,
  }),
  watch: {
    "ComprobanteFisc.cedrnc"() { this.programarClienteFiscalPos() },
    dialogComprobante(abierto) {
      if (abierto) this.programarClienteFiscalPos()
      else {
        this.cancelarConsultaFiscalPos()
        this.fiscalPosRnc = ""
      }
    },
  },
  beforeDestroy() { this.cancelarConsultaFiscalPos() },
  methods: {
    rncClienteFiscalPos() {
      return String(this.ComprobanteFisc.cedrnc || "").replace(/[\s-]/g, "")
    },
    sinConexionFiscalPos() {
      return this.pvOfflineForzado === true || this.pvOnline === false ||
        (typeof navigator !== "undefined" && navigator.onLine === false)
    },
    cancelarConsultaFiscalPos() {
      clearTimeout(this.fiscalPosTimer)
      this.fiscalPosTimer = null
      this.fiscalPosSolicitud++
      this.fiscalPosCargando = false
    },
    programarClienteFiscalPos() {
      this.cancelarConsultaFiscalPos()
      if (!this.dialogComprobante || this.fiscalPosGuardando) return
      const rnc = this.rncClienteFiscalPos()
      if (this.fiscalPosRnc && this.fiscalPosRnc !== rnc) {
        this.ComprobanteFisc.nombre = ""
        this.ComprobanteFisc.direccion = ""
      }
      this.fiscalPosRnc = rnc
      if (!/^(\d{9}|\d{11})$/.test(rnc) || this.sinConexionFiscalPos()) return
      this.fiscalPosTimer = setTimeout(() => {
        this.fiscalPosTimer = null
        this._clienteFiscalPosPromesa = this.buscarClienteFiscalPos()
      }, 400)
    },
    async buscarClienteFiscalPos() {
      const rnc = this.rncClienteFiscalPos()
      if (!this.dialogComprobante || !/^(\d{9}|\d{11})$/.test(rnc) || this.sinConexionFiscalPos()) return
      const solicitud = ++this.fiscalPosSolicitud
      const formulario = this.ComprobanteFisc
      const anterior = { nombre: formulario.nombre, direccion: formulario.direccion }
      this.fiscalPosCargando = true
      try {
        const res = await this.$axios.get(this.$hostname + this.$hName + "/padron-dgii/cliente-pos", {
          headers: this.$store.getters.GetheadersAxios, params: { identificacion: rnc }, timeout: 8000,
        })
        if (solicitud !== this.fiscalPosSolicitud || !this.dialogComprobante || formulario !== this.ComprobanteFisc || rnc !== this.rncClienteFiscalPos()) return
        if (res.data && res.data.encontrado && res.data.cliente) {
          Object.keys(anterior).forEach(campo => {
            // Do not replace edits made while the request was in flight.
            if (formulario[campo] === anterior[campo]) formulario[campo] = res.data.cliente[campo] || ""
          })
        }
      } catch (error) {
        if (solicitud === this.fiscalPosSolicitud && this.dialogComprobante) {
          this.alerta("No se pudo consultar el cliente fiscal. Puede completar los datos manualmente.", "warning")
        }
      } finally {
        if (solicitud === this.fiscalPosSolicitud) this.fiscalPosCargando = false
      }
    },
    async esperarClienteFiscalPos() {
      if (this.fiscalPosTimer !== null) {
        clearTimeout(this.fiscalPosTimer)
        this.fiscalPosTimer = null
        this._clienteFiscalPosPromesa = this.buscarClienteFiscalPos()
      }
      if (this._clienteFiscalPosPromesa) await this._clienteFiscalPosPromesa
    },
    async guardarClienteFiscalPos() {
      const rnc = this.rncClienteFiscalPos()
      if (!rnc || this.sinConexionFiscalPos()) return true
      try {
        await this.$axios.post(this.$hostname + this.$hName + "/padron-dgii/cliente-pos", {
          cedrnc: rnc, nombre: this.ComprobanteFisc.nombre,
          direccion: this.ComprobanteFisc.direccion,
        }, { headers: this.$store.getters.GetheadersAxios, timeout: 8000 })
        return true
      } catch (error) {
        this.alerta("No se pudieron guardar los datos del cliente fiscal. Revise la conexion y vuelva a pulsar Salvar.", "error")
        return false
      }
    },
  },
}
